import axios from 'axios'

export const FrontEndSearchService = {
  // get results of advance searched
  fetchAdvanceSearchList (data) {
    return axios.post(`/public/api/v1/advancesearch`, JSON.stringify({
      stateId: data.stateId,
      countyId: data.countyId,
      jurisdictionId: data.jurisdictionId
    }))
  },
  // get results of text searched
  fetchTextSearchList (data, filterId) {
    return axios.post(`/public/api/v1/search`, JSON.stringify({
      searchString: data,
      filterId: filterId
    }))
  },
  // books list on loading code adoption page
  fetchBooksOnLoad (data) {
    return axios.post(`/public/api/v1/bookmarksearch`, JSON.stringify({
      stateName: data.stateName,
      jurisdictionName: data.jurisdictionName,
      countyName: data.countyName,
      townshipName: data.townshipName,
      status: data.status
    }))
  },
  isLocationPresent (data) {
    return axios.post(`/public/api/v1/checkLocation`, JSON.stringify({
      stateName: data.stateName,
      jurisdictionName: data.jurisdictionName,
      countyName: data.countyName,
      townshipName: data.townshipName,
      locationLevel: data.locationLevel
    }))
  }
}
